export default "__VITE_ASSET__15e0f7d3__"